import 'flatpickr/dist/themes/material_blue.css'

import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { values } from 'lodash'

// Components
import OrganizationsNavi from 'app/views/components/OrganizationsNavi'
import Loader from 'app/views/components/Loader'

// Redux
import { getPlans } from 'app/state/modules/plan'
import { getTeamById, updateTeamById, deleteTeamById } from 'app/state/modules/team'

// Utils
import analytics from 'app/views/utils/analytics'


class OrganizationsTeamsUsersEdit extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      error: '',
      name: '',
      planId: '',
      confirmDelete: false,
    }

    this.handleChangeName = this.handleChangeName.bind(this)
    this.handleChangePlan = this.handleChangePlan.bind(this)
    this.handleSubmitSave = this.handleSubmitSave.bind(this)
    this.handleDeleteClick = this.handleDeleteClick.bind(this)
    this.handleDeleteConfirm = this.handleDeleteConfirm.bind(this)
    this.handleDeleteCancel = this.handleDeleteCancel.bind(this)
  }

  componentDidMount() {
    this.props.getPlans(this.props.match.params.organization_uuid)
    this.props.getTeamById(this.props.match.params.organization_uuid, this.props.match.params.team_uuid)
    if (this.props.currentTeam.uuid !== null) {
      this.setState({
        uuid: this.props.currentTeam.uuid,
        name: this.props.currentTeam.name,
        planId: this.props.currentTeam.plan.uuid,
      })
    }

    analytics.page('page-organizations-teams-users-edit')
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.currentTeam.uuid !== nextProps.currentTeam.uuid) {
      this.setState({
        uuid: nextProps.currentTeam.uuid,
        name: nextProps.currentTeam.name,
        planId: nextProps.currentTeam.plan.uuid,
      })
    }
  }

  handleChangeName(event) {
    this.setState({ name: event.target.value })
  }

  handleChangePlan(event) {
    this.setState({ planId: event.target.value })
  }

  handleSubmitSave(event) {
    event.preventDefault()

    if (this.state.name === '') {
      this.setState({ error: 'Name is required.' })
    } else {
      this.props.updateTeamById(
        this.props.match.params.organization_uuid,
        this.props.match.params.team_uuid,
        this.state.name,
        this.state.planId,
      ).then((teamId) => {
        this.props.history.push(`/admin/${this.props.match.params.organization_uuid}/teams/${teamId}`)
      })
    }
  }

  handleDeleteClick(e) {
    e.preventDefault()

    this.setState({ confirmDelete: true })
  }

  handleDeleteConfirm(e) {
    e.preventDefault()

    this.props.deleteTeamById(
      this.props.match.params.organization_uuid,
      this.props.match.params.team_uuid,
    ).then(() => {
      this.setState({ confirmDelete: false })
      this.props.history.push(`/admin/${this.props.match.params.organization_uuid}/teams`)
    })
  }

  handleDeleteCancel(e) {
    e.preventDefault()

    this.setState({ confirmDelete: false })
  }

  render() {
    if (this.props.plans.length === 0) {
      return <Loader visible />
    }
    return (
      <div className="uk-grid" data-uk-grid="">
        <div className="uk-width-medium@m uk-visible@m uk-background-muted" style={{ overflow: 'auto', height: 'calc(100vh - 80px)', borderRight: '1px solid #EEE' }}>
          <OrganizationsNavi active="teams" organizations={this.props.organizations} currentOrganizationId={this.props.match.params.organization_uuid} />
        </div>
        <div className="uk-padding-remove uk-width-expand@m uk-width-1-1@s" style={{ overflow: 'auto', height: 'calc(100vh - 80px)' }}>
          {(this.state.confirmDelete === false) ? (
            <div className="uk-padding" style={{ paddingLeft: 60 }} >
              <h1>Edit Team Users</h1>
              <div className="uk-card uk-card-default uk-card-body">
                <div className="uk-container-small">
                  <form className="uk-form-stacked">

                    <div className="uk-margin">
                      <label className="uk-form-label">Name</label>
                      <div className="uk-form-controls">
                        <input
                          className="uk-input"
                          type="text"
                          placeholder=""
                          value={this.state.name}
                          onChange={this.handleChangeName}
                        />
                      </div>
                    </div>

                    <div className="uk-margin">
                      <label className="uk-form-label">Training Plan</label>
                      <div className="uk-form-controls">
                        <select className="uk-select" id="from-select-plan-users-edit" value={this.state.planId} onChange={this.handleChangePlan}>
                          {values(this.props.plans).map((plan) => {
                            if (!plan.uuid) return null
                            return (
                              <option key={plan.uuid} value={plan.uuid}>{plan.title}</option>
                            )
                          })}
                        </select>
                      </div>
                    </div>

                    {(this.state.error !== '') &&
                      <div className="uk-margin">
                        <p className="uk-text-danger">{ this.state.error }</p>
                      </div>
                    }

                    {(this.props.updatingTeamByIdError !== '' && this.state.error === '') &&
                      <div className="uk-margin">
                        <p className="uk-text-danger">{ this.props.updatingTeamByIdError }</p>
                      </div>
                    }

                    {(this.props.deletingTeamByIdError !== '' && this.state.error === '' && this.props.updatingTeamByIdError === '') &&
                      <div className="uk-margin">
                        <p className="uk-text-danger">{ this.props.deletingTeamByIdError }</p>
                      </div>
                    }

                    <div className="uk-margin">
                      <div className="uk-form-controls">
                        <button className="uk-button uk-button-primary tm-button-default" onClick={this.handleSubmitSave}>Save Changes</button>
                        <a
                          href="#"
                          style={{ marginLeft: 10 }}
                          onClick={this.handleDeleteClick}
                        >
                          Delete Team
                        </a>
                      </div>
                    </div>

                  </form>
                </div>
              </div>
            </div>
          ) : (
            <div className="uk-padding" style={{ paddingLeft: 60 }} >
              <h1>Delete Team</h1>
              <div className="uk-card uk-card-default uk-card-body">
                <div className="uk-container-small">
                  <p>Are you sure you want to delete the team <strong>"{this.state.name}"</strong>?</p>
                  <form className="uk-form-stacked">
                    <div className="uk-margin">
                      <div className="uk-form-controls">
                        <button className="uk-button uk-button-danger tm-button-default" onClick={this.handleDeleteConfirm}>Delete</button>
                        <button className="uk-button uk-button tm-button-default" onClick={this.handleDeleteCancel}>Cancel</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  // content
  courses: state.content.courses,
  lessonMap: state.content.lessonMap,
  tests: state.content.tests,

  // hacker
  organizations: values(state.hacker.organizationsList),

  // plans
  plans: state.plan.plans,

  // team
  loadingTeamById: state.team.loadingTeamById,
  loadingTeamByIdError: state.team.loadingTeamByIdError,
  currentTeam: state.team.currentTeam,
  updatingTeamById: state.team.updatingTeamById,
  updatingTeamByIdError: state.team.updatingTeamByIdError,
  deletingTeamById: state.team.deletingTeamById,

})
const mapDispatchToProps = dispatch => ({
  getTeamById: (organizationId, teamId) => dispatch(getTeamById(organizationId, teamId)),
  updateTeamById: (organizationId, teamId, name, planId) => dispatch(updateTeamById(organizationId, teamId, name, planId)),
  deleteTeamById: (organizationId, teamId) => dispatch(deleteTeamById(organizationId, teamId)),
  getPlans: organizationId => dispatch(getPlans(organizationId)),
})
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OrganizationsTeamsUsersEdit))
